module.exports = __webpack_public_path__ + "static/media/greyprice.33658c8b.svg";